import profileRoute from './profile/route'
import talentCandidateProfileRoute from './talentCandidateProfile/route'
import potentialRoute from './potentialCandidateProfile/route'
import resumeRoute from './resume/route'
import batchUploadRoute from './batchUpload/route'
import talentResumeRoute from './talentResume/route'

export default [
  profileRoute,
  talentCandidateProfileRoute,
  potentialRoute,
  resumeRoute,
  batchUploadRoute,
  talentResumeRoute
]
